import React from "react";
import { Button } from "../../stories/Buttons/Button";
import succesTick from "../../assets/images/success-tick.png"

const PkbSuccessPage = () => {
  return (
    <div className="text-muted d-flex flex-column pkb-success-page">
      <img src={succesTick} className="mb-3" alt='success tick' />
      <strong><h3 className="text-mhc-green nb mb-2 ageo-bold mt-1">Success!</h3></strong>
      <p className="text-mhc-green ageo-semibold fs-26 mt-3">
        Thank you for connecting your results.
      </p>
      <p className="help-text">You will now be able to access your MyHealthChecked results in Patients Know Best alongside your NHS record. In some parts of England you can also use the NHS App, and some parts of Wales the NHS Wales App </p>
      <Button href={"/"} className="fs-20 btn-green" label={"Finish"} />
    </div>
  );
};

export default PkbSuccessPage;
